import Vue from 'vue'
import Vuex from 'vuex'
import settings from './modules/settings'

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    collapse: false,//导航栏显示和缩小
    menuType: true,//导航栏是否显示
    visitedViews: []
  },
  mutations: {
    updataCollapse(state, type) {
      state.collapse = type
    },
    updataMenuType(state, type) {
      state.menuType = type
    },
    addVisitedView: (state, view) => {
      if (state.visitedViews.some(v => v.path === view.path)) return;
      state.visitedViews.push(
        Object.assign({}, view, {
          title: view.name || 'no-name'
        })
      )
    },
    delVisitedView: (state, view) => {
      for (const [i, v] of state.visitedViews.entries()) {
        if (v.path === view.path) {
          state.visitedViews.splice(i, 1)
          break
        }
      }
    },
    emptyVisitedView: (state) => {
      state.visitedViews = []
    },
  },
  modules: {
    settings
  }
});

export default store



// WEBPACK FOOTER //
// ./src/store/index.js